// extracted by mini-css-extract-plugin
module.exports = {"map":"Map_map_2NpD9","logo":"Map_logo_3MU3_"};